import React from "react";
import { Box } from "@chakra-ui/react";
import { Section, type SectionProps } from "components/section";
import { TextTitle, type TextTitleProps } from "ui/text";
import { desktopOnlyDisplay, mobileOnlyDisplay } from "utils";
import {
  analyticsComparison,
  dataFlexibilityComparison,
  type FeatureComparisonRow,
  implementationEffortComparison,
  sourcesOfTruthComparison,
} from "./data";
import { ComparisonsTable } from "./comparisons-table";
import { ComparisonsTabs } from "./comparisons-tabs";

type TraditionalCdpVsHightouchProps = {
  title: TextTitleProps["title"];
  titleMaxW?: TextTitleProps["maxW"];
  description?: TextTitleProps["description"];
  descriptionMaxW?: TextTitleProps["descriptionMaxW"];
  actions?: TextTitleProps["actions"];
  rows?: FeatureComparisonRow[];
} & Omit<SectionProps, "title">;

export function TraditionalCdpVsHightouch({
  title,
  description,
  titleMaxW,
  descriptionMaxW,
  actions,
  rows = [dataFlexibilityComparison, sourcesOfTruthComparison, implementationEffortComparison, analyticsComparison],
  ...sectionProps
}: TraditionalCdpVsHightouchProps) {
  return (
    <Section {...sectionProps}>
      <TextTitle
        size="lg"
        align="center"
        maxW={titleMaxW}
        title={title}
        description={description}
        descriptionMaxW={descriptionMaxW}
        actions={actions}
      />

      <Box
        display={desktopOnlyDisplay()}
        bg="brand.background.light"
        boxShadow="md"
        borderRadius="bigger"
        p="30px"
        border="1px"
        borderColor="new.gray.50"
        mt="huge"
      >
        <ComparisonsTable rows={rows} />
      </Box>

      <Box display={mobileOnlyDisplay()} mt="bigger">
        <ComparisonsTabs comparisons={rows} />
      </Box>
    </Section>
  );
}
